import { OutlineXCircleErrorIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

export interface ILeaveInterviewCreationPopupProps {
  isOpen: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
}

/**
 * Shared "Unsaved Changes" popup used across the onsite-interview creation
 * flow (WorkDetailsPage form, ReviewAndConfirmPage, JobDetailsTabView).
 *
 * Extracted from the inline ConfirmPopup instances added in GOTU-2951 so the
 * copy, icon, and button labels live in one place.
 */
export const LeaveInterviewCreationPopup = ({
  isOpen,
  onDiscard,
  onKeepEditing,
}: ILeaveInterviewCreationPopupProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup is not typed
    <ConfirmPopup
      Icon={() => <OutlineXCircleErrorIcon size={74} color={colors.primary[500]} />}
      title="Unsaved Changes"
      titleStyle={{ marginBottom: 20, marginTop: 20 }}
      description="Keep editing to save your changes, or Discard to leave without saving."
      descriptionStyle={{ marginBottom: 40 }}
      leftButtonText="Discard"
      leftButtonAction={onDiscard}
      rightButtonText="Keep Editing"
      rightButtonAction={onKeepEditing}
    />
  );
};
